module.exports = __webpack_public_path__ + "static/media/Concept_Buildings_02.4c791461.jpg";